import {EventEmitter} from 'events';

export const EE = new EventEmitter();

export const ChartEditorEvent = 'ChartEditor-';
